import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';

export default {
  components: {
  },
  props: ['projectInfo', 'projectSubType', 'type'],
  data () {
    const validateCertificateNo = (rule, value, callback) => {
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    // 总金额校验
    const sumPriceValidate = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('请填写以上出租期限内的总金额'));
      } else if (Number(value) < 1 || Number(value) > 9999999999) {
        callback(new Error('请输入1-9999999999以内的数字'));
      } else {
        callback();
      }
    };
    return {
      typeArr: [],
      massifs: [
        {
          massifName: '',
          manufactureBrand: '',
          productModel: '',
          manufactureDate: '',
          area: '',
          price: '',
          otherCondition: '',
          originalContractor: '',
          certificateNo: ''
        }
      ],
      totalForm: {
        sumPrice: null,
        sumArea: null
      },
      pickerDisabled: {
        disabledDate: (time) => {
          return time.getTime() > new Date(new Date()).getTime();
        }
      },
      rules: {
        massifName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        manufactureBrand: [
          { required: true, message: '请选择生产厂家或品牌', trigger: 'change' }
        ],
        manufactureDate: [
          { required: true, message: '请选择出厂日期', trigger: 'change' }
        ],
        productModel: [
          { required: true, message: '请选择规格型号', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        otherCondition: [
          { required: true, message: '请输入配件及其他情况', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ],
        certificateNo: [
          { required: false, validator: validateCertificateNo, trigger: 'blur' }
        ]
      },
      totalFormRules: {
        sumPrice: [
          { required: true, validator: sumPriceValidate, trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    projectInfo: {
      handler () {
        const assetsInfo = this.projectInfo && this.projectInfo.assetsInfo && JSON.parse(this.projectInfo.assetsInfo);
        const arr = [];
        if (assetsInfo) {
          assetsInfo.forEach(item => {
            // const obj = JSON.parse(item);
            const obj = typeof item === 'string' ? JSON.parse(item) : item;
            Object.keys(obj).forEach((key) => {
              obj[key] = String(obj[key]);
            });
            arr.push(obj);
          });
        }
        if (arr.length) {
          this.massifs = arr;
        }
        Object.keys(this.totalForm).forEach((key) => {
          this.totalForm[key] = this.projectInfo && this.projectInfo[key] && String(this.projectInfo[key]);
        });
        this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length });
      },
      immediate: true
    }
  },
  created () {
    Service.getSelectList('MASSIF_TYPE').then(res => {
      if (res && res.code === '0') {
        this.typeArr = res.data;
      }
    });
  },
  methods: {
    priceVali (rule, value, callback) {
      if (value === '' || value === null) {
        callback(new Error('请输入总价格'));
      } else if (value < 1 || value > 9999999.99) {
        callback(new Error('请输入1-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali (rule, value, callback) {
      if (value === '' || value === null) {
        callback(new Error('请输入数量'));
      } else if (value <= 0 || value > 9999) {
        callback(new Error('请输入0-10000以内的数字'));
      } else {
        callback();
      }
    },
    clear () {
      if (this.projectInfo.projectType === 7) return false;
      this.massifs = [
        {
          massifName: '',
          manufactureBrand: '',
          productModel: '',
          manufactureDate: '',
          area: '',
          price: '',
          otherCondition: '',
          originalContractor: '',
          certificateNo: ''
        }
      ];
      this.totalForm = {
        sumPrice: null,
        sumArea: null
      };
      // 清空红色必填标示
      if (this.$refs['facilityForm']) {
        this.$refs['facilityForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        manufactureBrand: '',
        productModel: '',
        manufactureDate: '',
        area: '',
        price: '',
        otherCondition: '',
        originalContractor: '',
        certificateNo: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea;

      // let sumPrice = null;
      // this.massifs.forEach(item => {
      //   sumPrice += Number(item.price);
      // });
      // this.totalForm.sumPrice = sumPrice.toFixed(2);
      this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length });
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num;
    },
    // changePrice (event, index) {
    //   if (!RegExpObj.num.test(this.massifs[index].price)) {
    //     return;
    //   }
    //   this.massifs[index].price = this.massifs[index].price && Number(this.massifs[index].price).toFixed(2);
    //   let num = null;
    //   this.massifs.forEach(item => {
    //     num += Number(item.price);
    //   });
    //   this.totalForm.sumPrice = num.toFixed(2);
    //   this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    // },
    // 协议交易 出租金额
    changeCurrentPrice () {
      this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length });
    },
    test () {
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          form.price = 0;
          this.$refs[`landForm${index}`][0].validate((valid) => {
            if (valid) {
              num++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验总金额
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              console.log(this.totalForm, '==========tototalForm');
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifs)),
                ...this.totalForm
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    }
  }
};
